<div class="cst-component-container" [ngClass]="{'mini': mini}">
	<div class="cst-toggle-container" (click)="toggle()">
		<div class="indicator" [ngClass]="{'on': selected === 2}">&nbsp;</div>
		<div class="value" [ngClass]="{'on': selected === 1, 'disabled': disabled}">{{value1Display}}</div>
		<div class="value" [ngClass]="{'on': selected === 2, 'disabled': disabled}">{{value2Display}}</div>
	</div>
</div>